import {
  ExerciseDashboardDtoSchema,
  type ExerciseDashboardDto,
} from "@/modules/scores/scoreboard/gateway/scoreboardDto"
import type { ScoreApiGateway } from "@/modules/scores/scoreForms/gateway/scoreApiGateway"
import {
  MultipleSetScoreInputDtoSchema,
  type MultipleSetScoreInputDto,
} from "@/modules/scores/scoreForms/gateway/scoreDto"
import { LoggerService } from "@modules/common/logger/loggerService"
import { ApiClient } from "@modules/core/api/client/apiClient"

export class ScoreApi implements ScoreApiGateway {
  private programBaseUrl = "/programs"

  private buildExerciseUrl = (programId: string, sessionId: string, exerciseId: string) =>
    `${this.programBaseUrl}/${programId}/sessions/${sessionId}/exercises/${exerciseId}`

  constructor(private api: ApiClient) {}

  async addMultipleScoresToExercise(
    programId: string,
    sessionId: string,
    exerciseId: string,
    score: MultipleSetScoreInputDto,
  ): Promise<void> {
    await this.api.put(
      `${this.buildExerciseUrl(programId, sessionId, exerciseId)}/multipleScore`,
      LoggerService.parseApiDto(MultipleSetScoreInputDtoSchema, score),
    )
  }

  async getProgramExerciseDashboard(
    programId: string,
    sessionId: string,
    exerciseId: string,
  ): Promise<ExerciseDashboardDto> {
    const resultDto = await this.api.get<ExerciseDashboardDto>(
      `${this.programBaseUrl}/${programId}/sessions/${sessionId}/exercises/${exerciseId}/dashboard`,
      {
        params: { numberOfTopUsers: 5, numberOfLastParticipants: 5 },
      },
    )
    return LoggerService.parseApiDto(ExerciseDashboardDtoSchema, resultDto.data)
  }
}
